import { Space, Tag, Typography } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { FilterOutlined } from '@ant-design/icons';

import { ChatTagProps } from '../interface/chats.interface';
import { TableFilter } from '../../../../../shared/ui/TableFilter';
import { format } from '../../../../../shared/contants/date';

const { Text } = Typography;

export const getColumns = (getColumnSearchProps, updateFilters, filters) => [
    {
        title: <StyledTitle>Название сообщества</StyledTitle>,
        dataIndex: 'title',
        key: 'title',
        ...getColumnSearchProps('name', 'названию'),
    },
    {
        title: (
            <TableFilter
                icon={<FilterOutlined />}
                title='Дата добавления'
                setFilters={updateFilters}
                filters={filters}
            >
                <TableFilter.Date />
            </TableFilter>
        ),
        dataIndex: 'created_at',
        key: 'created_at',
        render: (createdAt: number) => format(createdAt)('DD.MM.YY'),
    },
    {
        title: (
            <TableFilter
                icon={<FilterOutlined />}
                onChange={tag_names => {
                    updateFilters({ tag_names });
                }}
                title='Теги'
                value={filters.tag_names}
            >
                <TableFilter.Tags />
            </TableFilter>
        ),
        dataIndex: 'tags',
        key: 'tags',
        render: (tags: ChatTagProps[]) => (
            <Space wrap>
                {tags.map(tag => (
                    <Tag key={tag.id}>{tag.name}</Tag>
                ))}
            </Space>
        ),
    },
];

const StyledTitle = styled(Text)`
    white-space: nowrap;
    font-weight: 600;
`;
